module.exports = __webpack_public_path__ + "img/qy (41).ead28adb.jpg";